import { getFollowStatsUrl, withQuery } from '@core/api'
import { httpClient } from '@core/http-client'

export const getFollowStatistics = (authors: string[], signal?: AbortSignal) => {
    return httpClient
        .get(withQuery(getFollowStatsUrl(), { ids: authors.join(',') }), { signal })
        .json<{
            [username: string]: {
                followers_count: number
                following_count: number
            }
        }>()
}
